module.exports = __webpack_public_path__ + "static/img/220.194.43.126.420020d3.png";